module.exports = __webpack_public_path__ + "img/small-black-arrow.cb19d385.svg";